import type { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { Spinner } from '@/components/ui/spinner';
import { cn } from '@/lib/utils';

export interface LoadingContainerProps {
  className?: string;
  label?: ReactNode;
  spinnerClassName?: string;
}

export const LoadingContainer: FC<LoadingContainerProps> = ({
  className,
  label,
  spinnerClassName,
}) => (
  <div className={cn('flex items-center gap-2', className)}>
    <Spinner className={spinnerClassName} />
    {label}
  </div>
);

interface FullscreenLoadingContainerProps {
  className?: string;
}

export const FullscreenLoadingContainer: FC<
  FullscreenLoadingContainerProps
> = ({ className }) => (
  <LoadingContainer
    className={cn(
      'flex h-full min-h-64 w-full items-center justify-center',
      className
    )}
    spinnerClassName='size-16'
  />
);

interface InputLoadingContainerProps {
  entityPlural: string;
}

export const InputLoadingContainer: FC<InputLoadingContainerProps> = ({
  entityPlural,
}) => {
  const { t } = useTranslation();

  return (
    <LoadingContainer
      className='w-full'
      label={t('general.fetchingEntities', {
        entityPlural,
      })}
    />
  );
};
